import React, { useState } from 'react';
import { Header } from '../components/layout/Header';
import { Footer } from '../components/layout/Footer';
import { contactInfo } from '../data/mock';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Textarea } from '../components/ui/textarea';
import { Label } from '../components/ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../components/ui/select';
import { Mail, Phone, MapPin, Clock, Send, CheckCircle2 } from 'lucide-react';
import { SEO } from '../components/SEO';
import { toast } from 'sonner';

// Comprehensive list of countries (200+)
const countries = [
  // Oceania - Australia first
  { value: "australia", label: "Australia", region: "Oceania" },
  // Asia - Major trade partners
  { value: "china", label: "China", region: "Asia" },
  { value: "india", label: "India", region: "Asia" },
  { value: "japan", label: "Japan", region: "Asia" },
  { value: "south-korea", label: "South Korea", region: "Asia" },
  { value: "singapore", label: "Singapore", region: "Asia" },
  { value: "indonesia", label: "Indonesia", region: "Asia" },
  { value: "malaysia", label: "Malaysia", region: "Asia" },
  { value: "vietnam", label: "Vietnam", region: "Asia" },
  { value: "thailand", label: "Thailand", region: "Asia" },
  { value: "philippines", label: "Philippines", region: "Asia" },
  // Middle East
  { value: "uae", label: "United Arab Emirates", region: "Middle East" },
  { value: "saudi-arabia", label: "Saudi Arabia", region: "Middle East" },
  { value: "qatar", label: "Qatar", region: "Middle East" },
  { value: "kuwait", label: "Kuwait", region: "Middle East" },
  { value: "bahrain", label: "Bahrain", region: "Middle East" },
  { value: "oman", label: "Oman", region: "Middle East" },
  // Rest of the world alphabetically
  { value: "afghanistan", label: "Afghanistan", region: "Asia" },
  { value: "albania", label: "Albania", region: "Europe" },
  { value: "algeria", label: "Algeria", region: "Africa" },
  { value: "andorra", label: "Andorra", region: "Europe" },
  { value: "angola", label: "Angola", region: "Africa" },
  { value: "antigua-and-barbuda", label: "Antigua and Barbuda", region: "Americas" },
  { value: "argentina", label: "Argentina", region: "Americas" },
  { value: "armenia", label: "Armenia", region: "Asia" },
  { value: "austria", label: "Austria", region: "Europe" },
  { value: "azerbaijan", label: "Azerbaijan", region: "Asia" },
  { value: "bahamas", label: "Bahamas", region: "Americas" },
  { value: "bangladesh", label: "Bangladesh", region: "Asia" },
  { value: "barbados", label: "Barbados", region: "Americas" },
  { value: "belarus", label: "Belarus", region: "Europe" },
  { value: "belgium", label: "Belgium", region: "Europe" },
  { value: "belize", label: "Belize", region: "Americas" },
  { value: "benin", label: "Benin", region: "Africa" },
  { value: "bhutan", label: "Bhutan", region: "Asia" },
  { value: "bolivia", label: "Bolivia", region: "Americas" },
  { value: "bosnia-and-herzegovina", label: "Bosnia and Herzegovina", region: "Europe" },
  { value: "botswana", label: "Botswana", region: "Africa" },
  { value: "brazil", label: "Brazil", region: "Americas" },
  { value: "brunei", label: "Brunei", region: "Asia" },
  { value: "bulgaria", label: "Bulgaria", region: "Europe" },
  { value: "burkina-faso", label: "Burkina Faso", region: "Africa" },
  { value: "burundi", label: "Burundi", region: "Africa" },
  { value: "cabo-verde", label: "Cabo Verde", region: "Africa" },
  { value: "cambodia", label: "Cambodia", region: "Asia" },
  { value: "cameroon", label: "Cameroon", region: "Africa" },
  { value: "canada", label: "Canada", region: "Americas" },
  { value: "central-african-republic", label: "Central African Republic", region: "Africa" },
  { value: "chad", label: "Chad", region: "Africa" },
  { value: "chile", label: "Chile", region: "Americas" },
  { value: "colombia", label: "Colombia", region: "Americas" },
  { value: "comoros", label: "Comoros", region: "Africa" },
  { value: "congo-drc", label: "Congo (DRC)", region: "Africa" },
  { value: "congo-republic", label: "Congo (Republic)", region: "Africa" },
  { value: "costa-rica", label: "Costa Rica", region: "Americas" },
  { value: "cote-divoire", label: "Côte d'Ivoire", region: "Africa" },
  { value: "croatia", label: "Croatia", region: "Europe" },
  { value: "cuba", label: "Cuba", region: "Americas" },
  { value: "cyprus", label: "Cyprus", region: "Europe" },
  { value: "czech-republic", label: "Czech Republic", region: "Europe" },
  { value: "denmark", label: "Denmark", region: "Europe" },
  { value: "djibouti", label: "Djibouti", region: "Africa" },
  { value: "dominica", label: "Dominica", region: "Americas" },
  { value: "dominican-republic", label: "Dominican Republic", region: "Americas" },
  { value: "ecuador", label: "Ecuador", region: "Americas" },
  { value: "egypt", label: "Egypt", region: "Africa" },
  { value: "el-salvador", label: "El Salvador", region: "Americas" },
  { value: "equatorial-guinea", label: "Equatorial Guinea", region: "Africa" },
  { value: "eritrea", label: "Eritrea", region: "Africa" },
  { value: "estonia", label: "Estonia", region: "Europe" },
  { value: "eswatini", label: "Eswatini", region: "Africa" },
  { value: "ethiopia", label: "Ethiopia", region: "Africa" },
  { value: "fiji", label: "Fiji", region: "Oceania" },
  { value: "finland", label: "Finland", region: "Europe" },
  { value: "france", label: "France", region: "Europe" },
  { value: "gabon", label: "Gabon", region: "Africa" },
  { value: "gambia", label: "Gambia", region: "Africa" },
  { value: "georgia", label: "Georgia", region: "Asia" },
  { value: "germany", label: "Germany", region: "Europe" },
  { value: "ghana", label: "Ghana", region: "Africa" },
  { value: "greece", label: "Greece", region: "Europe" },
  { value: "grenada", label: "Grenada", region: "Americas" },
  { value: "guatemala", label: "Guatemala", region: "Americas" },
  { value: "guinea", label: "Guinea", region: "Africa" },
  { value: "guinea-bissau", label: "Guinea-Bissau", region: "Africa" },
  { value: "guyana", label: "Guyana", region: "Americas" },
  { value: "haiti", label: "Haiti", region: "Americas" },
  { value: "honduras", label: "Honduras", region: "Americas" },
  { value: "hong-kong", label: "Hong Kong", region: "Asia" },
  { value: "hungary", label: "Hungary", region: "Europe" },
  { value: "iceland", label: "Iceland", region: "Europe" },
  { value: "iran", label: "Iran", region: "Middle East" },
  { value: "iraq", label: "Iraq", region: "Middle East" },
  { value: "ireland", label: "Ireland", region: "Europe" },
  { value: "israel", label: "Israel", region: "Middle East" },
  { value: "italy", label: "Italy", region: "Europe" },
  { value: "jamaica", label: "Jamaica", region: "Americas" },
  { value: "jordan", label: "Jordan", region: "Middle East" },
  { value: "kazakhstan", label: "Kazakhstan", region: "Asia" },
  { value: "kenya", label: "Kenya", region: "Africa" },
  { value: "kiribati", label: "Kiribati", region: "Oceania" },
  { value: "north-korea", label: "North Korea", region: "Asia" },
  { value: "kosovo", label: "Kosovo", region: "Europe" },
  { value: "kyrgyzstan", label: "Kyrgyzstan", region: "Asia" },
  { value: "laos", label: "Laos", region: "Asia" },
  { value: "latvia", label: "Latvia", region: "Europe" },
  { value: "lebanon", label: "Lebanon", region: "Middle East" },
  { value: "lesotho", label: "Lesotho", region: "Africa" },
  { value: "liberia", label: "Liberia", region: "Africa" },
  { value: "libya", label: "Libya", region: "Africa" },
  { value: "liechtenstein", label: "Liechtenstein", region: "Europe" },
  { value: "lithuania", label: "Lithuania", region: "Europe" },
  { value: "luxembourg", label: "Luxembourg", region: "Europe" },
  { value: "macau", label: "Macau", region: "Asia" },
  { value: "madagascar", label: "Madagascar", region: "Africa" },
  { value: "malawi", label: "Malawi", region: "Africa" },
  { value: "maldives", label: "Maldives", region: "Asia" },
  { value: "mali", label: "Mali", region: "Africa" },
  { value: "malta", label: "Malta", region: "Europe" },
  { value: "marshall-islands", label: "Marshall Islands", region: "Oceania" },
  { value: "mauritania", label: "Mauritania", region: "Africa" },
  { value: "mauritius", label: "Mauritius", region: "Africa" },
  { value: "mexico", label: "Mexico", region: "Americas" },
  { value: "micronesia", label: "Micronesia", region: "Oceania" },
  { value: "moldova", label: "Moldova", region: "Europe" },
  { value: "monaco", label: "Monaco", region: "Europe" },
  { value: "mongolia", label: "Mongolia", region: "Asia" },
  { value: "montenegro", label: "Montenegro", region: "Europe" },
  { value: "morocco", label: "Morocco", region: "Africa" },
  { value: "mozambique", label: "Mozambique", region: "Africa" },
  { value: "myanmar", label: "Myanmar", region: "Asia" },
  { value: "namibia", label: "Namibia", region: "Africa" },
  { value: "nauru", label: "Nauru", region: "Oceania" },
  { value: "nepal", label: "Nepal", region: "Asia" },
  { value: "netherlands", label: "Netherlands", region: "Europe" },
  { value: "new-zealand", label: "New Zealand", region: "Oceania" },
  { value: "nicaragua", label: "Nicaragua", region: "Americas" },
  { value: "niger", label: "Niger", region: "Africa" },
  { value: "nigeria", label: "Nigeria", region: "Africa" },
  { value: "north-macedonia", label: "North Macedonia", region: "Europe" },
  { value: "norway", label: "Norway", region: "Europe" },
  { value: "pakistan", label: "Pakistan", region: "Asia" },
  { value: "palau", label: "Palau", region: "Oceania" },
  { value: "palestine", label: "Palestine", region: "Middle East" },
  { value: "panama", label: "Panama", region: "Americas" },
  { value: "papua-new-guinea", label: "Papua New Guinea", region: "Oceania" },
  { value: "paraguay", label: "Paraguay", region: "Americas" },
  { value: "peru", label: "Peru", region: "Americas" },
  { value: "poland", label: "Poland", region: "Europe" },
  { value: "portugal", label: "Portugal", region: "Europe" },
  { value: "romania", label: "Romania", region: "Europe" },
  { value: "russia", label: "Russia", region: "Europe" },
  { value: "rwanda", label: "Rwanda", region: "Africa" },
  { value: "saint-kitts-and-nevis", label: "Saint Kitts and Nevis", region: "Americas" },
  { value: "saint-lucia", label: "Saint Lucia", region: "Americas" },
  { value: "saint-vincent-and-the-grenadines", label: "Saint Vincent and the Grenadines", region: "Americas" },
  { value: "samoa", label: "Samoa", region: "Oceania" },
  { value: "san-marino", label: "San Marino", region: "Europe" },
  { value: "sao-tome-and-principe", label: "São Tomé and Príncipe", region: "Africa" },
  { value: "senegal", label: "Senegal", region: "Africa" },
  { value: "serbia", label: "Serbia", region: "Europe" },
  { value: "seychelles", label: "Seychelles", region: "Africa" },
  { value: "sierra-leone", label: "Sierra Leone", region: "Africa" },
  { value: "slovakia", label: "Slovakia", region: "Europe" },
  { value: "slovenia", label: "Slovenia", region: "Europe" },
  { value: "solomon-islands", label: "Solomon Islands", region: "Oceania" },
  { value: "somalia", label: "Somalia", region: "Africa" },
  { value: "south-africa", label: "South Africa", region: "Africa" },
  { value: "south-sudan", label: "South Sudan", region: "Africa" },
  { value: "spain", label: "Spain", region: "Europe" },
  { value: "sri-lanka", label: "Sri Lanka", region: "Asia" },
  { value: "sudan", label: "Sudan", region: "Africa" },
  { value: "suriname", label: "Suriname", region: "Americas" },
  { value: "sweden", label: "Sweden", region: "Europe" },
  { value: "switzerland", label: "Switzerland", region: "Europe" },
  { value: "syria", label: "Syria", region: "Middle East" },
  { value: "taiwan", label: "Taiwan", region: "Asia" },
  { value: "tajikistan", label: "Tajikistan", region: "Asia" },
  { value: "tanzania", label: "Tanzania", region: "Africa" },
  { value: "timor-leste", label: "Timor-Leste", region: "Asia" },
  { value: "togo", label: "Togo", region: "Africa" },
  { value: "tonga", label: "Tonga", region: "Oceania" },
  { value: "trinidad-and-tobago", label: "Trinidad and Tobago", region: "Americas" },
  { value: "tunisia", label: "Tunisia", region: "Africa" },
  { value: "turkey", label: "Turkey", region: "Europe" },
  { value: "turkmenistan", label: "Turkmenistan", region: "Asia" },
  { value: "tuvalu", label: "Tuvalu", region: "Oceania" },
  { value: "uganda", label: "Uganda", region: "Africa" },
  { value: "ukraine", label: "Ukraine", region: "Europe" },
  { value: "united-kingdom", label: "United Kingdom", region: "Europe" },
  { value: "united-states", label: "United States", region: "Americas" },
  { value: "uruguay", label: "Uruguay", region: "Americas" },
  { value: "uzbekistan", label: "Uzbekistan", region: "Asia" },
  { value: "vanuatu", label: "Vanuatu", region: "Oceania" },
  { value: "vatican-city", label: "Vatican City", region: "Europe" },
  { value: "venezuela", label: "Venezuela", region: "Americas" },
  { value: "yemen", label: "Yemen", region: "Middle East" },
  { value: "zambia", label: "Zambia", region: "Africa" },
  { value: "zimbabwe", label: "Zimbabwe", region: "Africa" },
  { value: "puerto-rico", label: "Puerto Rico", region: "Americas" },
  { value: "guam", label: "Guam", region: "Oceania" },
];

const API_URL = process.env.REACT_APP_BACKEND_URL;

export default function ContactPage() {
  const [formData, setFormData] = useState({
    name: '',
    company: '',
    email: '',
    country: '',
    interest: '',
    message: '',
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSelectChange = (name, value) => {
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    
    try {
      // Get the country label for the selected value
      const selectedCountry = countries.find(c => c.value === formData.country);
      const countryLabel = selectedCountry ? selectedCountry.label : formData.country;
      
      const response = await fetch(`${API_URL}/api/contact/enquiry`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          ...formData,
          country: countryLabel, // Send the label instead of value
        }),
      });
      
      const data = await response.json();
      
      if (response.ok) {
        setIsSubmitted(true);
        toast.success('Thank you! Your enquiry has been received. We will contact you within 48 business hours.');
        
        // Reset form after delay
        setTimeout(() => {
          setIsSubmitted(false);
          setFormData({
            name: '',
            company: '',
            email: '',
            country: '',
            interest: '',
            message: '',
          });
        }, 3000);
      } else {
        toast.error(data.detail || 'Something went wrong. Please try again.');
      }
    } catch (error) {
      console.error('Form submission error:', error);
      toast.error('Unable to submit form. Please try again later.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen">
      <SEO
        title="Contact Us"
        path="/contact"
        description="Get in touch with Naviton Global for import and export enquiries. Based in Sydney, serving businesses across Australia and worldwide."
      />
      <Header />
      <main>
        {/* Hero Section */}
        <section className="pt-32 pb-20 bg-navy-900">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center">
              <span className="inline-block px-4 py-1.5 rounded-full bg-teal-500/20 text-teal-400 text-sm font-medium mb-6">
                Get In Touch
              </span>
              <h1 className="text-5xl md:text-6xl font-bold text-white mb-6">
                Start a Trade
                <span className="block text-teal-400">Conversation</span>
              </h1>
              <p className="text-xl text-slate-300 max-w-3xl mx-auto">
                Whether you're looking to export Australian products, source 
                quality goods for your market, or need domestic logistics support 
                across Australia — we're here to help.
              </p>
              <p className="text-base text-teal-400 mt-4 font-medium">
                Serving businesses nationwide — Sydney • Melbourne • Brisbane • Perth • Adelaide
              </p>
            </div>
          </div>
        </section>

        {/* Contact Section */}
        <section className="py-20 bg-white">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="grid lg:grid-cols-5 gap-16">
              {/* Contact Info */}
              <div className="lg:col-span-2 space-y-8">
                <div>
                  <h2 className="text-2xl font-bold text-navy-900 mb-6">Contact Information</h2>
                  <p className="text-slate-600 mb-8">
                    Reach out to us for enquiries about imports, exports, domestic logistics,
                    partnerships, or any trade-related questions. We serve businesses across Australia
                    and around the world.
                  </p>
                </div>

                <div className="space-y-6">
                  <div className="flex items-start gap-4">
                    <div className="p-3 rounded-xl bg-teal-100 flex-shrink-0">
                      <Mail className="h-6 w-6 text-teal-600" />
                    </div>
                    <div>
                      <h3 className="font-semibold text-navy-900 mb-1">Email</h3>
                      <a href={`mailto:${contactInfo.email}`} className="text-slate-600 hover:text-teal-600 transition-colors">
                        {contactInfo.email}
                      </a>
                    </div>
                  </div>

                  <div className="flex items-start gap-4">
                    <div className="p-3 rounded-xl bg-amber-100 flex-shrink-0">
                      <Phone className="h-6 w-6 text-amber-600" />
                    </div>
                    <div>
                      <h3 className="font-semibold text-navy-900 mb-1">Phone</h3>
                      <a href={`tel:${contactInfo.phone}`} className="text-slate-600 hover:text-amber-600 transition-colors">
                        {contactInfo.phone}
                      </a>
                    </div>
                  </div>

                  <div className="flex items-start gap-4">
                    <div className="p-3 rounded-xl bg-emerald-100 flex-shrink-0">
                      <MapPin className="h-6 w-6 text-emerald-600" />
                    </div>
                    <div>
                      <h3 className="font-semibold text-navy-900 mb-1">Address</h3>
                      <p className="text-slate-600 whitespace-pre-line">
                        {contactInfo.address}
                      </p>
                    </div>
                  </div>

                  <div className="flex items-start gap-4">
                    <div className="p-3 rounded-xl bg-slate-100 flex-shrink-0">
                      <Clock className="h-6 w-6 text-slate-600" />
                    </div>
                    <div>
                      <h3 className="font-semibold text-navy-900 mb-1">Business Hours</h3>
                      <p className="text-slate-600">
                        {contactInfo.businessHours}
                      </p>
                    </div>
                  </div>
                </div>

                {/* Sydney Map Image */}
                <div className="h-48 rounded-2xl overflow-hidden">
                  <img 
                    src="https://images.unsplash.com/photo-1506973035872-a4ec16b8e8d9?w=800&q=80" 
                    alt="Sydney, Australia - Sydney Harbour with Opera House"
                    className="w-full h-full object-cover"
                  />
                </div>
              </div>

              {/* Contact Form */}
              <div className="lg:col-span-3">
                <div className="bg-slate-50 p-8 md:p-10 rounded-3xl border border-slate-200">
                  <h2 className="text-2xl font-bold text-navy-900 mb-2">Request a Quote</h2>
                  <p className="text-slate-600 mb-8">Fill out the form below and we'll get back to you within 48 business hours.</p>

                  {isSubmitted ? (
                    <div className="text-center py-12" data-testid="enquiry-success-message">
                      <div className="p-4 w-fit mx-auto rounded-full bg-teal-100 mb-4">
                        <CheckCircle2 className="h-12 w-12 text-teal-600" />
                      </div>
                      <h3 className="text-xl font-semibold text-navy-900 mb-2">Thank You!</h3>
                      <p className="text-slate-600">Your enquiry has been received. We'll be in touch soon.</p>
                    </div>
                  ) : (
                    <form onSubmit={handleSubmit} className="space-y-6" data-testid="contact-enquiry-form">
                      <div className="grid md:grid-cols-2 gap-6">
                        <div className="space-y-2">
                          <Label htmlFor="name">Full Name *</Label>
                          <Input
                            id="name"
                            name="name"
                            data-testid="input-name"
                            value={formData.name}
                            onChange={handleInputChange}
                            placeholder="John Smith"
                            required
                            className="bg-white"
                          />
                        </div>
                        <div className="space-y-2">
                          <Label htmlFor="company">Company Name</Label>
                          <Input
                            id="company"
                            name="company"
                            data-testid="input-company"
                            value={formData.company}
                            onChange={handleInputChange}
                            placeholder="Your Company"
                            className="bg-white"
                          />
                        </div>
                      </div>

                      <div className="grid md:grid-cols-2 gap-6">
                        <div className="space-y-2">
                          <Label htmlFor="email">Email Address *</Label>
                          <Input
                            id="email"
                            name="email"
                            type="email"
                            data-testid="input-email"
                            value={formData.email}
                            onChange={handleInputChange}
                            placeholder="john@company.com"
                            required
                            className="bg-white"
                          />
                        </div>
                        <div className="space-y-2">
                          <Label htmlFor="country">Country *</Label>
                          <Select 
                            onValueChange={(value) => handleSelectChange('country', value)} 
                            required
                            value={formData.country}
                          >
                            <SelectTrigger className="bg-white" data-testid="select-country">
                              <SelectValue placeholder="Select country" />
                            </SelectTrigger>
                            <SelectContent className="max-h-[300px]">
                              {countries.map((country) => (
                                <SelectItem 
                                  key={country.value} 
                                  value={country.value}
                                  data-testid={`country-option-${country.value}`}
                                >
                                  {country.label}
                                </SelectItem>
                              ))}
                            </SelectContent>
                          </Select>
                        </div>
                      </div>

                      <div className="space-y-2">
                        <Label htmlFor="interest">What are you interested in? *</Label>
                        <Select 
                          onValueChange={(value) => handleSelectChange('interest', value)} 
                          required
                          value={formData.interest}
                        >
                          <SelectTrigger className="bg-white" data-testid="select-interest">
                            <SelectValue placeholder="Select your interest" />
                          </SelectTrigger>
                          <SelectContent>
                            <SelectItem value="Import Services">Import Services</SelectItem>
                            <SelectItem value="Export Services">Export Services</SelectItem>
                            <SelectItem value="Domestic Logistics">Domestic Logistics</SelectItem>
                            <SelectItem value="Agricultural Products">Agricultural Products</SelectItem>
                            <SelectItem value="Timber & Raw Materials">Timber & Raw Materials</SelectItem>
                            <SelectItem value="FMCG & Packaged Goods">FMCG & Packaged Goods</SelectItem>
                            <SelectItem value="Custom Sourcing">Custom Sourcing</SelectItem>
                            <SelectItem value="Partnership Opportunity">Partnership Opportunity</SelectItem>
                            <SelectItem value="Other">Other</SelectItem>
                          </SelectContent>
                        </Select>
                      </div>

                      <div className="space-y-2">
                        <Label htmlFor="message">Message *</Label>
                        <Textarea
                          id="message"
                          name="message"
                          data-testid="input-message"
                          value={formData.message}
                          onChange={handleInputChange}
                          placeholder="Tell us about your requirements, quantities, and any specific questions..."
                          rows={5}
                          required
                          className="bg-white resize-none"
                        />
                      </div>

                      <Button
                        type="submit"
                        disabled={isSubmitting}
                        data-testid="submit-enquiry-btn"
                        className="w-full bg-teal-600 hover:bg-teal-700 text-white py-6 rounded-xl text-lg"
                      >
                        {isSubmitting ? (
                          <span className="flex items-center gap-2">
                            <div className="w-5 h-5 border-2 border-white/30 border-t-white rounded-full animate-spin" />
                            Sending...
                          </span>
                        ) : (
                          <span className="flex items-center gap-2">
                            Send Enquiry
                            <Send className="h-5 w-5" />
                          </span>
                        )}
                      </Button>
                    </form>
                  )}
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
